import { Component, OnInit } from '@angular/core';
declare var $ : any;
declare var jQuery : any;
declare var d3:any,moment:any;
import * as _ from "lodash";
import 'datatables.net';
import 'datatables.net-bs4';
import { ActivatedRoute } from '@angular/router';
import { AlertService, ApiService } from 'src/app/services';
@Component({
  selector: 'app-default-plan',
  templateUrl: './default-plan.component.html',
  styleUrls: ['./default-plan.component.css']
})
export class DefaultPlanComponent implements OnInit {


  planList:any = []
  constructor( private route: ActivatedRoute, 
    private apiService: ApiService , 
    private alertService: AlertService,) { }

  ngOnInit() {
    this.getplanList();
  }

  getplanList(){
    if ($.fn.DataTable.isDataTable('#plan-table-list')){
      $('#plan-table-list').DataTable({"order": [],paging:false, "destroy": true,"columnDefs": [{ "orderable": false, "targets": [9,10] }]}).destroy();
    };
    let URL = 'billingRange/list'
    
    this.apiService.getAll(URL).subscribe(
      data => {
        if(data.statusCode == 100){
          this.planList = data.responseList;

          setTimeout(() => {
            const table: any = $('#plan-table-list');
            let dataTable = table.DataTable({"order": [], paging:true, "searching":true, "destroy": true,"columnDefs": [{ "orderable": false, "targets": [3] }]});
          }, 1000);
        }else{
          this.planList = [];
          const table: any = $('#plan-table-list');
          let dataTable = table.DataTable({"order": [],paging:true,searching:true, "destroy": true,"columnDefs": [{ "orderable": false, "targets": [3] }]});
        }
      },
      error => {
        this.alertService.errorMessage(error, error.status, "Something went wrong, please try again ");
      }
    ); 
  }

}
